import {clientLog} from "../clientLog";
import {publishingTagsInDb} from "./publishingTagsInDb";
import {saveNewTags} from "./saveNewTags";
import {createTagReference} from "./createTagReference";
import {savePublishingTagsWithModel} from "../publishing-tags/savePublishingTagsWithModel";

export const addPublishingTagsToModel = async (
    user,
    damsId,
    model,
    tags,
    museums,
    museumCollections,
    successCallback = null,
    errorCallback = null) => {

    const handleError = (error) => {
        clientLog('error', error, 'addtagstomodel');
    };

    if (!model) {
        throw new Error('Model is required to add tags.');
    }

    if (!tags) {
        throw new Error('Tags are required to add to the model.');
    }

    if (!Array.isArray(tags)) {
        throw new Error('Tags must be an array.');
    }

    const {collectionId} = model;
    let tagsAlreadyInDb = await publishingTagsInDb(collectionId, museums, museumCollections, handleError);

    const tagsToBeCreated = tags.filter(tag =>
        !tagsAlreadyInDb.some(t => (t.title.toLowerCase() === tag.inputValue.toLowerCase())));

    let savedTags = {'results': [], 'errors': []};
    if (tagsToBeCreated.length > 0) {
        savedTags = await saveNewTags(user, damsId, collectionId, tagsToBeCreated, '', 'publishing-');
        if (savedTags['errors'].length > 0) {
            if (errorCallback && typeof errorCallback === 'function') {
                errorCallback(savedTags['errors']);
            }
            return;
        }
    }

    const newTags = savedTags['results'].map(tag => {
        const {reference, publishingType} = tag;
        const {id, uniqueId, locale, title, source, content} = reference;
        return createTagReference(user, damsId, id, uniqueId, locale, title, source, content, publishingType);
    });

    const existingTags = tagsAlreadyInDb.map(tag => {
        const {id, uniqueId, locale, title, source, content, documentType} = tag;
        return createTagReference(user, damsId, id, uniqueId, locale, title, source, content, documentType);
    });

    const uniqueTagsByTitle = Array.from(new Map([...newTags, ...existingTags].map(item => [item.reference.title, item])).values());

    // Get the tags to add to the model, by merging new and existing tags,
    // and filtering them against the selected tags.
    const tagsToAdd = uniqueTagsByTitle.filter(t => tags.some(tt => tt.inputValue === t.reference.title));

    const res = await savePublishingTagsWithModel(model, tagsToAdd);

    if (successCallback && typeof successCallback === 'function') {
        await successCallback(res);
    } else {
        return res;
    }
};